<script lang="ts">
  import { onMount } from 'svelte';
  import { emoji, searchEmoji } from '../lib/emoji';

  let { onPick, onClose }: { onPick: (name: string) => void; onClose: () => void } = $props();

  let query = $state('');
  let input: HTMLInputElement | undefined = $state();
  let root: HTMLDivElement | undefined = $state();
  const names = $derived(searchEmoji(query));

  onMount(() => {
    input?.focus();
    const outside = (event: PointerEvent) => {
      if (root && !root.contains(event.target as Node)) onClose();
    };
    // Next tick: the click that opened the picker must not close it.
    const id = setTimeout(() => addEventListener('pointerdown', outside));
    return () => {
      clearTimeout(id);
      removeEventListener('pointerdown', outside);
    };
  });
</script>

<div
  class="picker"
  bind:this={root}
  role="dialog"
  aria-label="Choisir une réaction"
  tabindex="-1"
  onkeydown={(e) => e.key === 'Escape' && onClose()}
>
  <label class="sr-only" for="emoji-search">Chercher un emoji par son nom</label>
  <input id="emoji-search" class="input" placeholder="Chercher (ex. tada, coffee)" bind:this={input} bind:value={query} />
  <div class="grid">
    {#each names as name (name)}
      <button type="button" title=":{name}:" aria-label=":{name}:" onclick={() => onPick(name)}>{emoji(name)}</button>
    {:else}
      <p class="none">Aucun emoji pour « {query} »</p>
    {/each}
  </div>
</div>

<style>
  .picker {
    position: absolute;
    z-index: 20;
    right: 0;
    top: 100%;
    margin-top: 4px;
    width: 280px;
    padding: 8px;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius-l);
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.16);
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .input {
    height: 34px;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 2px;
    max-height: 200px;
    overflow-y: auto;
  }
  .grid button {
    height: 32px;
    border: 0;
    border-radius: var(--radius-s);
    background: transparent;
    font-size: 18px;
  }
  .grid button:hover,
  .grid button:focus-visible {
    background: var(--bg-hover);
  }
  .none {
    grid-column: 1 / -1;
    margin: 4px;
    color: var(--muted);
    font-size: 13px;
  }
</style>
